import { OperatorInterface } from "utils"

export const DECATHLON_NAME = "Decathlon"
export const DECATHLON_ID = "DK"
export const DECATHLON_SUBDOMAIN = "decathlon"

export const decathlonConfiguration: OperatorInterface = {
		name: DECATHLON_NAME,
		id: DECATHLON_ID,
		subDomain: DECATHLON_SUBDOMAIN,
        url: "decathlon.o-code.co",
		folderName: "decathlon",
        cguUrl: "https://legal.o-code.co/bike/Decathlon/Owner/CGU/fr/CGU_Decathlon_20230601.pdf",
        legalNoticeUrl: "https://legal.o-code.co/bike/Decathlon/Owner/ML/fr/MentionsLegales_Decathlon_20211201.pdf",
	    privacyPolicyUrl: "https://legal.o-code.co/bike/Decathlon/Owner/PDC/fr/PolitiqueDeConfidentialite_Decathlon_20230621.pdf",
		faqAccordionLength: 6,
		theme: {
            primaryColor: "#0082C3",
            primaryColorHover: "#00537d",
			primaryColorLigthen: "#FFFEFC",
            secondaryColor: "#EC6607",
            formBackgroundColor: "#F7F8F9",
            insaleBike: "#4E6F56",
            insaleBikeHover: "#3e5844",
            secondaryColorLighten: "#F6AEA1",
            secondaryColorHover: "#C15E29",
            placeholderColor: "#93C2CF",
		}
}